<template>
    <page>
        <module enable-flex :title="title" ref="view">
            <m-search ref="search" @search="searchHandle">
                <c-form ref="form" inline>
                    <c-form-item type="input" label="会员昵称" name="nick_name" placeholder="模糊匹配昵称"></c-form-item>
                    <c-form-item type="input" label="手机号" name="user_manage_mobilephone" placeholder="模糊匹配手机号"></c-form-item>
                    <c-form-item type="select" label="会员等级" name="user_level" options="USER_LEVEL_AUTH" placeholder="会员等级"></c-form-item>
                    <c-form-item type="datetime" label="报名时间" start-name="start_date" end-name="end_date"></c-form-item>
                </c-form>
            </m-search>
            <m-operate>
                <c-button color="m" hollow @click="syncExport()">导出报名记录</c-button>

                <template #right>
                    <c-button v-if="userInfo.id == 1" color="red" @click="$refs.view.editExportColumn(workType)">编辑导出列</c-button>
                </template>
            </m-operate>

            <c-table ref="table" height="770">
                <c-table-column label="会员头像" width="100">
                    <template v-slot="{data}">
                        <div class="flex-center-cross">
                            <c-image :src="data.head_photo" preview size="30" style="margin-right: 10px;"></c-image>
                        </div>
                    </template>
                </c-table-column>
                <c-table-column label="会员昵称" name="nick_name" width="150">
                    <template v-slot="{data}">
                        <span>{{data.nick_name||'-'}}</span>
                    </template>
                </c-table-column>
                <c-table-column label="手机号" name="user_manage_mobilephone" width="120">
                    <template v-slot="{data}">
                        <span>{{data.user_manage_mobilephone||'-'}}</span>
                    </template>
                </c-table-column>
                <c-table-column label="会员等级" name="level_name" width="120"></c-table-column>
                <c-table-column label="报名时间" name="create_date" width="155"></c-table-column>
            </c-table>
        </module>
    </page>
</template>

<script>

    import {mapState} from "vuex";

    export default {
        name: 'm_offline_activity_apply',

        data() {
            return {
                title:'健康活动报名记录',
                serachParams:{},
                workType:34
            }
        },

        computed: {
            ...mapState(['systemConfig', 'userInfo'])
        },

        props: {
            id: String
        },

        watch: {
            id() {
                this.getDetail();
                this.$refs.search.search();
            }
        },

        mounted() {
            this.$refs.search.search();
            this.$bus.$on('offineActivityRecordList.update', () => {
                this.$refs.search.search();
            });
            this.getDetail();
        },

        methods: {
            //查询活动详情
            getDetail(){
                var data = {};
                data.id = this.id;
                console.log();
                this.request({
                    url: '/offineActivity/detail',
                    data:data,
                    success: data => {
                        this.title = '健康活动【'+data.title+'】报名记录';
                    }
                });
            },
            //查询列表
            searchHandle(data) {
                data.activity_id = this.id;
                this.$refs.table.load({
                    url: '/offineActivity/record/list',
                    data
                });
                this.searchParams = data||{};
            },
            /**同步导出数据*/
            syncExport(type){
                var selectDatas = this.$refs.table.getRow('selected');
                var ids = [];
                if (selectDatas.length && selectDatas.length>0) {
                    ids = Array.from(selectDatas, item => item.data.id);
                }
                this.export(this.workType,this.searchParams,ids);
            },
        }
    }
</script>